import axios from "../axios";
import { getQueryString } from "utils/getQueryString";

const getAll = (queryParams) => {
  return axios.get(`/financial-statements?${getQueryString(queryParams)}`);
};

const create = (data) => {
  return axios.post("/financial-statements", data);
};

const update = (financialStatementId, data) => {
  return axios.put(`/financial-statements/${financialStatementId}`, data);
};

const get = (financialStatementId) => {
  return axios.get(`/financial-statements/${financialStatementId}`);
};

const remove = (financialStatementId) => {
  return axios.delete(`/financial-statements/${financialStatementId}`);
};

const financialStatementDataService = {
  getAll,
  create,
  update,
  get,
  remove,
};

export default financialStatementDataService;
